import React, { useState } from 'react';
import axios from 'axios';
import EmployeeProcessService from '../services/EmployeeProcessService';
import { toast } from 'react-toastify';
import { useLoading } from '../Utils/LoadingContext';
import showToast from "../Utils/ToastContainer";

function AttendanceUpload() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
  e.preventDefault();

  if (!file) {
    toast.error("Please choose a file before uploading.");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    setUploading(true);

    const response = await EmployeeProcessService.setAttendance(formData);

    if (response?.data?.result > 0) {
      showToast("Attendance Uploaded.", 'success');
    } else {
      toast.error("Employee not found");
    }
  } catch (error) {
    alert("Upload failed");
    console.error("Upload error:", error);
  } finally {
    setUploading(false);
  }
};

  return (
    <>
      <form onSubmit={handleUpload} className="upload-form">
        <div className="row">
          <div className="col-12 mb-3 border-bottom pb-2">
            <h4 className="text-left text-primary">Attendance Upload Setup</h4>
          </div>
          <div className="form-group col-md-6">
            <input type="file" onChange={handleFileChange} />
          </div>
            <div className="form-group col-md-2">
            <button type="submit" disabled={uploading}>
              {uploading ? "Uploading..." : "Upload"}
            </button>
            
            {message && <p className="message">{message}</p>}</div>
        </div>
        {!file && message && (
  <div className="text-danger">Please choose a file to upload.</div>
)}
      </form>
      

    </>
  );
}

export default AttendanceUpload;
